import { contentId, isSaved, isPublished, contentAnalytics } from '../state'

/**
 * Reset content state
 */
export const resetContentState = () => {
  contentId.value = null
  isSaved.value = false
  isPublished.value = false
  contentAnalytics.value = {
    views: 0,
    likes: 0,
    comments: 0,
    shares: 0,
  }
}
